import { User } from './auth.type';
import { Language, Currency } from './preference.type';

export interface UserState {
    user: User | null;
    isSessionExpired: boolean;
    isAccessTokenExpired: boolean;
    language: Language;
    currency: Currency;
    hidePage: boolean;
}

export enum UserActions {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    SESSION_EXPIRED = 'SESSION_EXPIRED',
    ACCESS_TOKEN_EXPIRED = 'ACCESS_TOKEN_EXPIRED',
    SET_CURRENCY = 'SET_CURRENCY',
    SET_LANGUAGE = 'SET_LANGUAGE',
    SET_HIDE_PAGE = 'SET_HIDE_PAGE',
}

interface UserLogIn {
    type: typeof UserActions.LOGIN;
    payload: User;
}

interface UserLogout {
    type: typeof UserActions.LOGOUT;
}

interface SessionExpired {
    type: typeof UserActions.SESSION_EXPIRED;
    payload: boolean;
}

interface SetAccessTokenExpired {
    type: typeof UserActions.ACCESS_TOKEN_EXPIRED;
    payload: boolean;
}

interface SetCurrency {
    type: typeof UserActions.SET_CURRENCY;
    payload: Currency;
}

interface SetLanguage {
    type: typeof UserActions.SET_LANGUAGE;
    payload: Language;
}

interface SetHidePage {
    type: typeof UserActions.SET_HIDE_PAGE;
    payload: boolean;
}

export type UserActionTypes = UserLogIn | UserLogout | SessionExpired | SetCurrency | SetLanguage | SetHidePage | SetAccessTokenExpired;
